import { PWA_CONFIG } from './config/pwa.config';
import { injectPWAManifest, injectPWAMetaTags } from './utils/pwa';
import { registerServiceWorker } from './utils/serviceWorker';

export const initPWA = async () => {
  try {
    // First, unregister any old service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations.length > 0) {
        for (const registration of registrations) {
          await registration.unregister();
        }
      }
    }

    const hostname = window?.location?.hostname || '';
    let website = PWA_CONFIG.COMPANY_WEBSITE || 'your-website';    
    try {
      const parts = hostname.split('.').filter(Boolean);
      if (parts.length > 1 && !hostname.includes('localhost')) {
        website = parts[0];
      } 
    } catch (err) {
      console.warn('PWA website detection failed, using fallback:', website);
    }
    try {
      const manifestInjected = injectPWAManifest(website);
      if (!manifestInjected) {
        console.warn('PWA manifest injection failed');
      }
    } catch (err) {
      console.warn('PWA manifest error:', err.message);
    }

    try {
      await injectPWAMetaTags(website);
    } catch (err) {
      console.warn('PWA meta tags error:', err.message);
    }

    try {
      const swRegistration = await registerServiceWorker(website);
      if (swRegistration) {
      }
    } catch (err) {
      // Service worker registration is optional; app works without it
      console.warn('ℹ️ Service worker not available:', err.message);
    }
  } catch (error) {
    console.error('initPWA failed:', error);
  }
};

export default initPWA;
